import React from 'react';
import { useSelector } from 'react-redux';

import CarRentalsStep1 from '@icons/car-rentals-step1.svg';
import CarRentalsStep2 from '@icons/car-rentals-step2.svg';
import CarRentalsStep3 from '@icons/car-rentals-step3.svg';

import { getTranslationsState } from '@redux/selectors';

import styles from './CarRentalSteps.module.scss';

const CarRentalSteps: React.FC = () => {
  const translations = useSelector(getTranslationsState);

  const steps = [
    {
      Icon: <CarRentalsStep1 width={160} height={163} />,
      step: translations.car_rentals_step_1_title,
      description: translations.car_rentals_step_1_description,
    },
    {
      Icon: <CarRentalsStep2 width={160} height={163} />,
      step: translations.car_rentals_step_2_title,
      description: translations.car_rentals_step_2_description,
    },
    {
      Icon: <CarRentalsStep3 width={160} height={163} />,
      step: translations.car_rentals_step_3_title,
      description: translations.car_rentals_step_3_description,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>{translations.car_rentals_steps_main_title}</h2>
      </div>

      <div className={styles.stepsGrid}>
        {steps.map((stepData) => (
          <div key={stepData.step} className={styles.stepCard}>
            <div className={styles.iconsContainer}>{stepData.Icon}</div>
            <h3 className={styles.stepTitle}>{stepData.step}</h3>
            <p className={styles.stepDescription}>{stepData.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CarRentalSteps;
